import React, { useMemo } from 'react';
import { useCanvasTransformationScale } from '../utils/canvas-transformation-context';
import { getRectAfterCrop } from '../utils/get-dimensions-after-crop';
import { useItem } from '../utils/use-context';

export const SelectionDimensions: React.FC<{
  itemId: string;
}> = ({ itemId }) => {
  const item = useItem(itemId);
  const rectAfterCrop = useMemo(() => {
    if (!item) {
      return { width: 0, height: 0, left: 0, top: 0 };
    }
    return getRectAfterCrop(item);
  }, [item]);

  if (!item) {
    return null;
  }

  const scale = useCanvasTransformationScale();

  const outerStyle: React.CSSProperties = useMemo(() => {
    return {
      marginBottom: -30 / scale,
    };
  }, [scale]);

  const innerStyle: React.CSSProperties = useMemo(() => {
    return {
      padding: 3 / scale,
      fontSize: 11 / scale,
      lineHeight: `${15 / scale}px`,
    };
  }, [scale]);

  return (
    <div
      className="pointer-events-none absolute bottom-0 flex w-full flex-row items-center justify-center"
      style={outerStyle}
    >
      <div
        className="inline-block bg-editor-starter-accent text-xs text-white"
        style={innerStyle}
      >
        {Math.floor(rectAfterCrop.width)}x{Math.floor(rectAfterCrop.height)}
      </div>
    </div>
  );
};
